import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdmAutocadastroService } from 'src/app/shared/api/adm-autocadastro.service';
import { AdmEquipeService } from 'src/app/shared/api/adm-equipe.service';
import { AdmSkinService } from 'src/app/shared/api/adm-skin.service';
import { LicencasDisponiveisAdmService } from 'src/app/shared/api/licencas/licencas-disponiveis-adm.service';
import { clonarObjeto } from 'src/app/shared/functions/objects-functions';
import { equipeResource } from '../../equipes/equipe.resource';

@Component({
    selector: 'app-forms-equipes-cliente',
    templateUrl: './forms-equipes-cliente.component.html',
    styleUrls: ['./forms-equipes-cliente.component.css']
})
export class FormsEquipesClienteComponent implements OnInit {
    equipeResource = clonarObjeto(equipeResource) as typeof equipeResource;
    entidade!: any;
    showAutocadastro = false;

    idCliente!: string;

    licencasDisponiveisLiberarService!: LicencasDisponiveisAdmService;

    constructor(
        public equipeService: AdmEquipeService,
        private route: ActivatedRoute,
        private admSkinService: AdmSkinService,
        public autocadastroService: AdmAutocadastroService,
        public licencasDisponiveisAdmService: LicencasDisponiveisAdmService,
        private injector: Injector
    ) {}

    ngOnInit(): void {
        this.idCliente = this.route.snapshot.paramMap.get('id')!;
        this.equipeService.setBaseUrl(this.idCliente);
        this.admSkinService.setBaseUrl(this.idCliente);

        const skin = this.equipeResource.colunas.find(coluna => coluna.field === 'skin');
        skin!.lookupConfiguration!.instanciaService = this.admSkinService;

        this.licencasDisponiveisLiberarService = this.criarInstanciaLicencasDisponiveis();
    }

    changeEntidadeOriginal(equipe: any) {
        this.entidade = equipe;
        this.licencasDisponiveisAdmService.setBaseUrl(this.idCliente, {
            equipe: equipe[this.equipeResource.fieldPk]
        });
        this.licencasDisponiveisLiberarService.setBaseUrl(this.idCliente, { equipe: null });
        this.autocadastroService.setBaseUrl(equipe[this.equipeResource.fieldPk]);
        this.showAutocadastro = true;
    }

    private criarInstanciaLicencasDisponiveis(): LicencasDisponiveisAdmService {
        return Injector.create({
            providers: [
                { provide: LicencasDisponiveisAdmService, useClass: LicencasDisponiveisAdmService }
            ],
            parent: this.injector
        }).get(LicencasDisponiveisAdmService);
    }
}
